export const mainContainerStyles = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  marginTop: { xs: "75px", md: "0px" },
};

export const communityBtnBoxStyle = {
  display: { xs: "flex", md: "none" },
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  flexWrap: "wrap",
  pb: "30px",
};

export const communityBtnStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  background: "#fff",
  border: "1px solid #EAEAEA",
  borderRadius: "8px",
  px: "16px",
  py: "12px",
  cursor: "pointer",

  "&:hover": {
    background: "#F5F5F5",
  },
};

export const autoCompleteStyles = {
  maxWidth: "655px",

  "& .MuiInputBase-root": {
    height: "56px",
    borderRadius: "80px",
    color: "#3E3F4CB2",
    fontWeight: 400,
    fontSize: "15px",
    px: "24px",
    py: "17px",
    background: "#FFFF",

    "& fieldset": { borderColor: "#EAEAEA" },

    "&:hover fieldset": {
      borderColor: "#46a091",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46a091",
    },
  },
};

export const autoCompletePopperStyles = {
  mt: "10px !important",
  borderRadius: "16px !important",
  boxShadow: "2px 2px 16px 0px #00000029",

  "& .MuiPaper-root": {
    borderRadius: "16px !important",
  },
};

export const loaderBoxStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  background: "rgba(255, 255, 255, 0.5)",
  zIndex: 9999,
};

export const containerStyle = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
};

export const loaderContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: 1,
  height: "100%",
};

export const circularProgressStyle = {
  color: "#248B70",
};

export const pricelistTitleStyle = {
  mb: "20px",
  mt: "44px",
  fontSize: "19px",
  fontWeight: "500",
  color: "#2F2B3D",
};

export const pricelistGridStyle = {
  my: 2,
  display: "grid",
  gap: "16px",
  gridTemplateColumns: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(auto-fit, minmax(var(--card-width, 200px), auto))",
  },
  justifyContent: "start",
  "--card-width": "200px",
};

export const referenceCardStyle = {
  visibility: "hidden",
  gridColumn: "1 / -1",
  position: "absolute",
  pointerEvents: "none",
  height: 0,
  overflow: "hidden",
  "& > *": {
    display: "inline-block",
  },
};

export const cardWrapperStyle = {
  position: "relative",
  display: "flex",
};

export const closeButtonStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  color: "#3E3F4C80",
  zIndex: 1,
};

export const noPricelistStyle = {
  mt: "44px",
  fontSize: "19px",
  fontWeight: "500",
  color: "#2F2B3D",
};

export const textField = {
  width: { xs: "100%", sm: "auto" },
  "& .MuiOutlinedInput-root": {
    width: { xs: "100%", sm: "220px" },
    height: "39px",
    fontWeight: 400,
    fontSize: "14px",
    color: "rgba(62, 63, 76, 0.7)",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    paddingLeft: "12px",
    "& input": {
      paddingY: "10px",
    },
    "& fieldset": {
      borderWidth: "1px",
      borderColor: "#EAEAEA",
    },
    "&:hover fieldset": {
      borderWidth: "1px",
      borderColor: "#3e3f4c",
    },
    "&.Mui-focused fieldset": {
      borderWidth: "1px",
      borderColor: "#3e3f4c",
    },
  },
};

export const scrollbarContainerStyle = {
  ...containerStyle,
  gap: "40px",
  flexBasis: 0,
  overflowY: "auto",
  marginRight: { xs: "-5px", md: "-15px" },
  paddingRight: { xs: "3px", md: "12px" },
  overflowX: "hidden",
};

export const pricelistContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

export const pricelistTitleText = {
  fontSize: "18px",
  fontWeight: 600,
  lineHeight: "24px",
};

export const pricelistCardStyle = {
  width: "215px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  borderBottomLeftRadius: "8px",
  borderBottomRightRadius: "8px",
  boxShadow: "0px 0px 6.01px 0px rgba(0, 0, 0, 0.08)",
};

export const pricelistCardImageStyle = {
  width: "100%",
  height: "130px",
  borderTopLeftRadius: "12px",
  borderTopRightRadius: "12px",
  position: "relative",
};

export const pricelistCardRemoveIconStyle = {
  zIndex: 1,
  position: "absolute",
  top: "6px",
  right: "9px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: "rgba(183, 72, 74, 1)",
  },
};

export const pricelistCardContentStyle = {
  flex: 1,
  p: "18px",
  display: "flex",
  flexDirection: "column",
};

export const pricelistCardNameStyle = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "21px",
};

export const pricelistCardServicesStyle = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "15px",
  mt: "6px",
};

export const pricelistCardOverlayStyle = {
  position: "absolute",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  background:
    "linear-gradient(180deg, rgba(0, 31, 26, 0.3) 1.2%, rgba(0, 31, 26, 0) 100%)",
};

export const managePricelistButtonStyle = {
  mt: "16px",
  width: "max-content",
  backgroundColor: "rgba(242, 243, 251, 1)",
  color: "rgba(37, 124, 109, 1)",
  textTransform: "capitalize",
  boxShadow: "none",
  padding: "8px 12px",
  borderRadius: "6px",
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: "18px",
  whiteSpace: { xs: "wrap", sm: "nowrap" },
  "&:hover": {
    backgroundColor: "rgba(221, 233, 232, 1)",
    boxShadow: "none",
  },
};

export const noPricelistBoxStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  border: "1px solid rgba(234, 234, 234, 1)",
  borderRadius: "12px",
  mb: "15px",
};

export const noPricelistTextStyle = {
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "28px",
  mt: "16px",
  color: "rgba(72, 72, 72, 0.9)",
};

export const noPricelistTextDescriptionStyle = {
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "100%",
  mt: "6px",
  color: "rgba(72, 72, 72, 0.9)",
};

export const allPricelistWrapperStyle = {
  ...pricelistContainerStyle,
  gap: 0,
  flex: 1,
  position: "relative",
};

export const allPricelistTitleBoxStyle = {
  display: "flex",
  gap: "8px",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "24px",
  backgroundColor: "#f8f7fa",
  position: "sticky",
  top: 0,
  zIndex: 1,
};

export const allPricelistGridStyle = {
  pb: "16px",
  flex: 1,
  display: "grid",
  gap: { xs: "16px", sm: "26px" },
  gridTemplateColumns: {
    xs: "repeat(2, 1fr)",
    sm: "repeat(3, 1fr)",
    md: "repeat(4, 1fr)",
  },
  justifyContent: "start",
  overflowX: "hidden",
};

export const allPricelistCardStyle = {
  ...pricelistCardStyle,
  height: "max-content",
  minHeight: "100%",
  width: { xs: "100%", sm: "100%" },
};

export const allPricelistCardContentStyle = {
  flex: 1,
  p: "18px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
};

export const allPricelistCardNameStyle = {
  ...pricelistCardNameStyle,
  fontSize: "18px",
  lineHeight: "28px",
  textAlign: "center",
};

export const allPricelistButtonStyle = {
  mt: "16px",
  width: "100%",
  backgroundColor: "rgba(37, 124, 109, 1)",
  color: "#fff",
  textTransform: "capitalize",
  boxShadow: "none",
  padding: "12px",
  borderRadius: "6px",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "100%",
  whiteSpace: { xs: "wrap", sm: "nowrap" },
  "&:hover": {
    backgroundColor: "rgba(30, 109, 91, 1)",
    boxShadow: "none",
  },
};

export const noAllPricelistBoxStyle = {
  ...noPricelistBoxStyle,
  border: "none",
  borderRadius: "0px",
  mt: "24px",
};

export const noResultTextStyle = {
  fontSize: "24px",
  fontWeight: 600,
  lineHeight: "100%",
  mt: "16px",
};

export const noResultDescriptionStyle = {
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "160%",
  mt: "32px",
  textAlign: "center",
};

export const requestPricelistButtonStyle = {
  ...allPricelistButtonStyle,
  width: "max-content",
  mt: "24px",
  borderRadius: "9000px",
  paddingX: "16px",
  textTransform: "none",
};

export const feesPricingButtonStyle = {
  backgroundColor: "rgba(255, 255, 255, 1)",
  color: "rgba(37, 124, 109, 1)",
  padding: "8px 12px",
  borderRadius: "900px",
  height: "36px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "20px",
  textDecoration: "underline",
  cursor: "pointer",
};

export const subcategoryNameTextStyle = {
  color: "rgba(72, 72, 72, 1)",
  fontSize: "19px",
  fontWeight: 500,
  lineHeight: "120%",
  mb: "16px",
};

export const addPricesTextStyle = {
  color: "rgba(72, 72, 72, 0.7)",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
};

export const subpricelistNameTextStyle = {
  color: "rgba(72, 72, 72, 1)",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "120%",
};
